import React from 'react';

import { ButtonSocial } from '@components';

import * as styles from './Social.module.scss';

export const Social: React.FC = () => {
	return (
		<div className={styles.socialMedia}>
			<p className={styles.orange}>Folgen Sie uns:</p>
			<div className={styles.socialIcons}>
				<ButtonSocial
					url="https://www.linkedin.com/company/embiq"
					target="_blank"
					linkTitle="LinkedIn link"
					icon="linkedIn"
				/>
				<ButtonSocial
					url="https://www.facebook.com/embiq"
					target="_blank"
					linkTitle="Facebook link"
					icon="facebook"
				/>
				<ButtonSocial
					url="https://www.instagram.com/embiq_official/?hl=en"
					target="_blank"
					linkTitle="Instagram link"
					icon="instagram"
				/>
			</div>
		</div>
	);
};
